import { render, staticRenderFns } from "./PageParametersEdit.vue?vue&type=template&id=5b5f267c"
import script from "./PageParametersEdit.vue?vue&type=script&lang=js"
export * from "./PageParametersEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports